import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function NotificationPopup() {
  const { user } = useAuth();
  const [notif, setNotif] = useState(null);

  useEffect(() => {
    if (!user) return;
    api
      .get("/notifications/me")
      .then(({ data }) => {
        if (Array.isArray(data) && data.length > 0) setNotif(data[0]);
      })
      .catch(() => {});
  }, [user]);

  const dismiss = async () => {
    if (!notif) return;
    try {
      await api.post(`/notifications/${notif.id}/dismiss`);
    } catch {}
    setNotif(null);
  };

  if (!notif) return null;

  const imgSrc = notif.image_path
    ? notif.image_path.startsWith("http")
      ? notif.image_path
      : `${process.env.REACT_APP_BACKEND_URL}/api/files/${notif.image_path}`
    : null;

  return (
    <div className="fixed inset-0 z-[60] bg-bg/80 backdrop-blur-md flex items-end sm:items-center justify-center p-4" onClick={dismiss}>
      <div className="glass rounded-3xl max-w-md w-full overflow-hidden card-lift" onClick={(e) => e.stopPropagation()} data-testid="notif-popup">
        {imgSrc && <img src={imgSrc} alt={notif.title} className="w-full aspect-video object-cover" />}
        <div className="p-6">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-lime">Eventom</div>
              <div className="font-display uppercase text-2xl mt-1 leading-tight" data-testid="notif-title">{notif.title}</div>
            </div>
            <button onClick={dismiss} data-testid="notif-close" className="icon-circle !w-9 !h-9 bg-white/5">
              <X className="w-4 h-4" />
            </button>
          </div>
          <p className="mt-3 text-sm text-text/85 whitespace-pre-wrap" data-testid="notif-message">{notif.message}</p>
          {notif.cta_url && (
            <a href={notif.cta_url} onClick={dismiss} target="_blank" rel="noopener noreferrer" className="mt-5 btn-primary justify-center w-full" data-testid="notif-cta">
              {notif.cta_label || "Learn more"} →
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
